import { TStorageDrawer } from "types";

export const MAGLOCK_MAX = 12;

/**
 * Validates a drawer's maglock number against the rest of the toolbox. Two drawers sharing a
 * magnet means denying either holds both, and the device cannot detect it — this is the only
 * place it is caught.
 */
export const validateMaglockNumber = (
  value: number | null | undefined,
  drawers: TStorageDrawer[],
  currentDrawerValue: number,
): string | undefined => {
  if (value === null || value === undefined || Number.isNaN(value)) return undefined;

  if (value < 1 || value > MAGLOCK_MAX) {
    return `Maglock number must be between 1 and ${MAGLOCK_MAX}.`;
  }

  const clash = drawers.find(
    (drawer) => drawer.value !== currentDrawerValue && drawer.maglockNumber === value,
  );
  if (clash) {
    return `Maglock ${value} is already used by drawer ${clash.value}.`;
  }

  return undefined;
};
